import { Theme as StyledSystemTheme } from 'styled-system';

import breakpoints, { Breakpoints } from './breakpoints';
import colors from './colors';
import {
  alert,
  accordion,
  buttonSizes,
  buttons,
  featureGrid,
  quote,
  cards,
  form,
  headings,
  hero,
  links,
  logoSection,
  nav,
  paper,
  tileSizes,
  videoCarousel,
  videoPlayer,
  wave,
} from './components';
import { Headings } from './components/headings';
import * as shared from './shared/index';
import fonts, { Fonts } from './fonts';
import fontSizes, { FontSizeVariants } from './font-sizes';
import keyframe from './keyframes';
import radii, { Radii } from './radii';
import shadows, { Shadows } from './shadows';
import space, { Spaces } from './space';
import typography, { Typography } from './typography';
import zIndices, { ZIndices } from './z-indices';
import * as Colors from '../types/colors';

export interface LucidTheme
  extends Fonts,
    Omit<
      StyledSystemTheme,
      | 'colors'
      | 'buttons'
      | 'fonts'
      | 'fontSizes'
      | 'fontWeights'
      | 'lineHeights'
      | 'letterSpacings'
      | 'radii'
      | 'shadows'
    > {
  breakpoints: Breakpoints;
  colors: Colors.Base;
  fontSizes: FontSizeVariants;
  radii: Radii;
  shadows: Shadows;
  space: Spaces;
  zIndices: ZIndices;
  // keyframes
  keyframe: typeof keyframe;
  // shared css blocks
  shared: typeof shared;
  // components
  alert: typeof alert;
  accordion: typeof accordion;
  buttonSizes: typeof buttonSizes;
  buttons: typeof buttons;
  quote: typeof quote;
  cards: typeof cards;
  featureGrid: typeof featureGrid;
  form: typeof form;
  headings: Headings;
  hero: typeof hero;
  links: typeof links;
  logoSection: typeof logoSection;
  nav: typeof nav;
  paper: typeof paper;
  tileSizes: typeof tileSizes;
  typography: Typography;
  videoCarousel: typeof videoCarousel;
  videoPlayer: typeof videoPlayer;
  wave: typeof wave;
}

export const theme: LucidTheme = {
  ...fonts,
  breakpoints,
  colors,
  fontSizes,
  radii,
  shadows,
  space,
  zIndices,
  // keyframe
  keyframe,
  // shared
  shared,
  // components
  alert,
  accordion,
  buttonSizes,
  buttons,
  quote,
  cards,
  featureGrid,
  form,
  headings,
  hero,
  links,
  logoSection,
  nav,
  paper,
  tileSizes,
  typography,
  videoCarousel,
  videoPlayer,
  wave,
};

export default theme;
